import { CheckCircleOutline, HighlightOffRounded } from '@material-ui/icons';
import React, { memo } from 'react';
import { OrgAssociateStatus } from 'src/types';
import PendingIcon from '../Icons/PendingIcon';

type Props = {
  status: OrgAssociateStatus;
};

export const StatusIcon: React.FC<Props> = ({ status }) => {
  if (status === OrgAssociateStatus.Approved) {
    return <CheckCircleOutline data-testid="approved-icon" />;
  }
  if (status === OrgAssociateStatus.Active) {
    return <CheckCircleOutline data-testid="active-icon" />;
  }
  if (status === OrgAssociateStatus.Inactive) {
    return <HighlightOffRounded data-testid="inactive-icon" />;
  }
  return <PendingIcon data-testid="pending-icon" />;
};

export default memo(StatusIcon);
